import { Component } from '@angular/core';
import { IFloatingFilterAngularComp } from '@ag-grid-community/angular';
import { ListingStatusEnum } from 'shared/constants/listing-statuses';
import { IFloatingFilterParams } from '@ag-grid-community/core/dist/esm/es6/filter/floating/floatingFilter';
import { FilterChangedEvent } from '@ag-grid-community/core/dist/esm/es6/events';

@Component({
    selector: 'app-listing-status-floating-filter',
    templateUrl: './listing-status-floating-filter.component.html',
    styleUrls: ['./listing-status-floating-filter.component.scss'],
    standalone: false,
})
export class ListingStatusFloatingFilterComponent implements IFloatingFilterAngularComp {
    private params!: IFloatingFilterParams;
    public parentFilter: any;

    agInit(params: IFloatingFilterParams): void {
        this.params = params;
    }

    showParentFilter() {
        this.params.showParentFilter();
    }

    onParentModelChanged(parentModel: any, filterChangedEvent?: FilterChangedEvent | null): void {
        if (parentModel?.values) {
            parentModel.values = parentModel?.values.sort((a: string, b: string) => {
                const indexA = Object.values(ListingStatusEnum).findIndex((elem) => elem == a);
                const indexB = Object.values(ListingStatusEnum).findIndex((elem) => elem == b);

                if (indexA < indexB) {
                    return -1;
                }
                if (indexA > indexB) {
                    return 1;
                }

                return 0;
            });
        }
        this.parentFilter = parentModel;
    }
}
